export default [
  {
    path: 'settings',
    name: 'Cài đặt',
    component: () => import('@/views/setting/ConfigRole.vue'),
    meta: {
      title: 'Cài đặt quyền truy cập',
      auth: true,
      permission: 'config-roles',
    },
  },
]
